define('views/blocks/AuthentificationLoginView',['underscore', 'backbone', 'jquery', 'app', 'SubView',
        'views/blocks/AuthentificationView',
        'template!authentification'
    ],

    function (_, Backbone, $, app, SubView,
              AuthentificationView,
              authentificationTemplate
              ) {

        return Backbone.View.extend(SubView).extend({

            events:{
                'click .btn-close':'close'
            },

            initialize:function(options){
                var view = this;
                view.subviews = [];
                view.options = _.defaults(options,{introduction:false});
                view.listenToOnce(app.getCustomer(), 'login', view.close);
                view.render();
            },

            render:function(){
                var view = this;
                view.$el.html(authentificationTemplate(view.options));
                view.appendView(AuthentificationView,'.authentification-block',
                    {register: false,  newsletter:false, render:true, comeinId:0, flagcomin:0});
            },

            close:function(){
                this.trigger('close', this);
            }



        });


    });


